import {
  AccountInfo,
  AuthenticationResult,
  EventType,
  PublicClientApplication,
} from '@azure/msal-browser';
import { toast } from 'react-toastify';
import { toastOptions } from '@/shared/utils';
import { msalConfig, loginRequest } from '../authConfig';
import { msalErrorMessages } from './constants/msalErrorConstants';
import { msalStatusMessages } from './constants/msalStatusConstants';

export const msalInstance = new PublicClientApplication(msalConfig);

export const logoutRequest = {
  account: msalInstance.getActiveAccount(),
  postLogoutRedirectUri: '/',
};

export class MsalHelper {
  static async initializeMsal() {
    await msalInstance.initialize();

    const accounts = msalInstance.getAllAccounts();

    if (accounts.length > 0) {
      msalInstance.setActiveAccount(accounts[0]);
      this.checkSessionExpiry(accounts[0]);
    }

    msalInstance.addEventCallback(async event => {
      if (event.eventType === EventType.LOGIN_SUCCESS && event.payload) {
        const payload = event.payload as AuthenticationResult;
        const { account } = payload;
        msalInstance.setActiveAccount(account);
      }
    });
  }

  static handleLogin() {
    msalInstance.loginRedirect(loginRequest).catch(() => {
      toast.error(msalErrorMessages.loginError, toastOptions);
    });
    toast.success(msalStatusMessages.redirectingToLogin, toastOptions);
  }

  static handleLogout() {
    msalInstance.logoutRedirect(logoutRequest).catch(() => {
      toast.error(msalErrorMessages.logoutError, toastOptions);
    });
  }

  static checkSessionExpiry(account: AccountInfo) {
    const currentTime = Math.floor(Date.now() / 1000);
    const exptTime = account.idTokenClaims?.exp;

    if (exptTime && exptTime < currentTime) {
      this.handleLogout();
    }
  }
}
